import {useI18n} from 'store/Store'
import {FormRow} from '../Form/Forms'
import FormSelect from 'components/Control/Form/FormSelect'
import FormDateTimePicker from 'components/Control/Form/FormDateTimePicker'
import {days, occurrences} from 'constants/sessions'

const OccurrenceFields = ({occurrenceValue, control, errors}) => {
    const {i18n} = useI18n()

    return (
        <>
            <FormRow>
                <FormSelect
                    name="occurrences"
                    itemsName="sessions"
                    optionsName="occurrences"
                    label={i18n.t(`sessions.occurrence`)}
                    options={occurrences}
                    control={control}
                    error={errors.occurrences?.message}
                />

                {(occurrenceValue === 'WEEKLY' ||
                    occurrenceValue === 'MONTHLY') && (
                    <FormSelect
                        itemsName="sessions"
                        optionsName="days"
                        name="day"
                        label={i18n.t(`sessions.day`)}
                        options={days}
                        control={control}
                        error={errors.day?.message}
                    />
                )}

                {occurrenceValue === 'MONTHLY' && (
                    <FormSelect
                        name="week"
                        label={i18n.t(`sessions.week`)}
                        control={control}
                        error={errors.week?.message}
                        options={Array.from({length: 4}, (_, index) =>
                            (index + 1).toString()
                        )}
                    />
                )}
            </FormRow>

            {occurrenceValue === 'ONCE' && (
                <FormRow>
                    <FormDateTimePicker
                        name="startDateAndTime"
                        label={i18n.t(`sessions.startDateAndTime`)}
                        control={control}
                        error={errors.startDateAndTime?.message}
                    />

                    <FormDateTimePicker
                        name="endDateAndTime"
                        label={i18n.t(`sessions.endDateAndTime`)}
                        control={control}
                        error={errors.endDateAndTime?.message}
                    />
                </FormRow>
            )}
        </>
    )
}

export default OccurrenceFields
